import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHealthy = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		transform: "translate(2 2)",
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#1DAD70",
			rx: 10
		}), /* @__PURE__ */ _jsx("path", {
			stroke: "#FFF",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 2,
			d: "M6 7L6 11 14 11",
			transform: "rotate(-45 10 9)"
		})]
	})
});
export default SvgHealthy;
